export default __webpack_public_path__ + "static/media/trendingUp.99bd8bbb.svg";